import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "newPackagesModalRef",
  id: "kt_modal_new_packages",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_packages_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_packages_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_packages_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_packages_scroll",
  "data-kt-scroll-offset": "500px"
}
const _hoisted_9 = { class: "row mb-5" }
const _hoisted_10 = { class: "col-md-12 fv-row mb-5" }
const _hoisted_11 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_12 = { class: "col-lg-11 fv-row" }
const _hoisted_13 = { class: "row mb-5" }
const _hoisted_14 = { class: "col-md-12 fv-row mb-5" }
const _hoisted_15 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_16 = { class: "col-lg-11 fv-row" }
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = { class: "col-md-12 fv-row" }
const _hoisted_19 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "col-md-12 fv-row mb-3" }
const _hoisted_23 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-5" }
const _hoisted_27 = { class: "col-md-12 fv-row mb-3" }
const _hoisted_28 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_29 = { class: "col-lg-12 fv-row" }
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "+964", -1)
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "col-md-12 fv-row mb-3" }
const _hoisted_35 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_36 = { class: "col-lg-12 fv-row" }
const _hoisted_37 = { class: "input-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "+964", -1)
const _hoisted_39 = { class: "fv-plugins-message-container" }
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { class: "col-md-12 fv-row mb-3" }
const _hoisted_42 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-5" }
const _hoisted_46 = { class: "col-md-12 fv-row" }
const _hoisted_47 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "modal-footer flex-center" }
const _hoisted_51 = {
  type: "reset",
  "data-bs-dismiss": "modal",
  id: "kt_modal_new_packages_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_52 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_packages_submit",
  class: "btn btn-primary"
}
const _hoisted_53 = { class: "indicator-label" }
const _hoisted_54 = { class: "indicator-progress" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_packages_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.translate('addNewPackages')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('Governorate')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedGovernorate,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGovernorate) = $event)),
                        "close-on-select": false,
                        requierd: false,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.governorateTitle(),
                        placeholder: _ctx.translate('select Governorate'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedArea,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedArea) = $event)),
                        "close-on-select": false,
                        requierd: false,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areasTitle(),
                        placeholder: _ctx.translate('selectArea'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate('holderName')), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('holderName'),
                        name: "holderName"
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_ErrorMessage, { name: "holderName" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('docId')), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('docId'),
                        name: "docId"
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_ErrorMessage, { name: "docId" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.translate('recipientPhoneNumber')), 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "recipientPhoneNumber",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('recipientPhoneNumber')
                          }, null, 8, ["placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_ErrorMessage, { name: "recipientPhoneNumber" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.translate('secondRecipientPhoneNumber')), 1),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "secondRecipientPhoneNumber",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('secondRecipientPhoneNumber')
                          }, null, 8, ["placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_ErrorMessage, { name: "secondRecipientPhoneNumber" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.translate('address')), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('address'),
                        name: "address"
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_ErrorMessage, { name: "address" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate('notes')), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: _ctx.translate('notes'),
                        name: "notes"
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_ErrorMessage, { name: "notes" })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", _hoisted_51, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", _hoisted_52, [
                _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_54, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_55
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}